var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgListViewGray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.004,
    height: 18,
    viewBox: "0 0 19.004 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: none;\r\n        stroke: #606060;\r\n        stroke-linecap: round;\r\n        stroke-width: 2px;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_9795",
    "data-name": "Group 9795",
    transform: "translate(-1467 -162)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9488",
    "data-name": "Group 9488",
    transform: "translate(1468 163)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7011",
    "data-name": "Path 7011",
    className: "cls-1",
    d: "M0,1.309H1",
    transform: "translate(0 -1.309)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7012",
    "data-name": "Path 7012",
    className: "cls-1",
    d: "M0,1.309H12.528",
    transform: "translate(4.477 -1.309)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9487",
    "data-name": "Group 9487",
    transform: "translate(1468 168.333)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7013",
    "data-name": "Path 7013",
    className: "cls-1",
    d: "M0,1.309H1",
    transform: "translate(0 -1.309)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7014",
    "data-name": "Path 7014",
    className: "cls-1",
    d: "M0,1.309H12.528",
    transform: "translate(4.477 -1.309)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9489",
    "data-name": "Group 9489",
    transform: "translate(1468 179)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7015",
    "data-name": "Path 7015",
    className: "cls-1",
    d: "M0,1.309H1",
    transform: "translate(0 -1.309)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7016",
    "data-name": "Path 7016",
    className: "cls-1",
    d: "M0,1.309H12.528",
    transform: "translate(4.477 -1.309)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9490",
    "data-name": "Group 9490",
    transform: "translate(1468 173.667)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7015-2",
    "data-name": "Path 7015",
    className: "cls-1",
    d: "M0,1.309H1",
    transform: "translate(0 -1.309)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7016-2",
    "data-name": "Path 7016",
    className: "cls-1",
    d: "M0,1.309H12.528",
    transform: "translate(4.477 -1.309)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgListViewGray);
export default __webpack_public_path__ + "static/media/ListViewGray.4d8314e8d9cd2d463d1433efe48d7a5d.svg";
export { ForwardRef as ReactComponent };